import { render, staticRenderFns } from "./OnboardingImportUrlModal.vue?vue&type=template&id=f05e2bbc&scoped=true"
import script from "./OnboardingImportUrlModal.vue?vue&type=script&lang=js"
export * from "./OnboardingImportUrlModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingImportUrlModal.vue?vue&type=style&index=0&id=f05e2bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05e2bbc",
  null
  
)

export default component.exports